export default "__VITE_ASSET__8bb237f9__"